import { useContext } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { fontSizes, fontWeights, colors } from '@/styles'
import checkEmailImg from './images/check-email.png'
import BackButton from './back-button'
import Context from '../context'

const Container = styled.div`
  width: 100%;
`

const HeadingText = styled.p`
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.bold};
  margin: 32px 0;
  text-align: center;
  color: ${colors.black};
`

const DescriptionText = styled.p`
  font-size: ${fontSizes.regular};
  font-weight: ${fontWeights.regular};
  margin-top: 0;
  text-align: center;
  color: ${colors.grey24};
`

const Bold = styled.span`
  font-weight: ${fontWeights.medium};
  display: block;
  margin-top: 4px;
`

const Image = styled.div`
  width: 100%;
  height: 160px;
  background: url(${checkEmailImg}) 50% 100% no-repeat;
  background-size: auto 100%;
  margin-top: 5px;
`

const CheckEmail = () => {
  const { t } = useTranslation()
  const { email, setEmail, setUsername, setCurrentStep } = useContext(Context)

  return (
    <>
      <BackButton
        onClick={() => {
          setEmail('')
          setUsername('')
          setCurrentStep('login')
        }}
      />
      <Container>
        <Image />
        <HeadingText>
          {t('b.auth.view.link_on_its_way.text', 'The link is on its way!')}
        </HeadingText>
        <DescriptionText>
          <Trans i18nKey="b.auth.view.check_email.text" email={email}>
            We emailed a link to <Bold>{{ email }}</Bold>
          </Trans>
        </DescriptionText>
      </Container>
    </>
  )
}

export default CheckEmail
